// ** Redux Imports
import { createAsyncThunk } from '@reduxjs/toolkit'
import { apiMethods } from '@services/methods'
import { getUserData } from '@utils'

// import { baseURL } from '@services/common'
// ** Axios Imports
import axios from 'axios'
import {
  addUser,
  setAction,
  setAlertModal,
  setBankOptions,
  setForm,
  setFormInfo,
  setFunds,
  setInfoModal,
  setKidsList,
  setMobilePayment,
  setRechargeMethods,
  setRechargeMethodsModal,
  setRecordData,
  setSelectedKid,
  setSelectedMethod,
  setStatusModal,
  setTransferInfo,
  setTypeOtp,
  setUpdateModal,
  setUser,
  setVehicle,
  setWiretransfer,
  showUser,
  showVehicle
} from './slice'

import { BasicToastContent } from '@src/components/basic-toast-content'
import toast from 'react-hot-toast'

const baseURL = process.env.REACT_APP_USERV2
const baseURLV1 = process.env.REACT_APP_USER

const endpoints = {
  kidsList: `${baseURL}/customer/child`,
  addKid: `${baseURL}/customer/child/add`,
  deleteKid: `${baseURL}/customer/child/delete`,
  updateKidStatus: `${baseURL}/customer/child/status-update`,
  updateKid: `${baseURL}/customer/child/update`,
  getRechargeMethods: `${baseURLV1}/customer/recharges/new-methods`,
  getRecord: `${baseURLV1}/customer/transactions`,
  getFormInfo: `${baseURLV1}/child/info`,
  getConstans: `${baseURLV1}/constants`,
  bankTransferRecharge: `${baseURLV1}/customer/recharges`,
  sendOtp: `${baseURLV1}/customer/recharges/credicard/send-token`,
  creditRecharge: `${baseURLV1}/customer/recharges/credicard`,
  getFunds: `${baseURL}/customer/user-check-funds`,
  bdvRecharge: `${baseURLV1}/customer/recharges/bdv`,
  bdvRechargeConfirm: `${baseURLV1}/customer/recharges/bdv/confirm-token`

}

export const showModal = (action) => {
  return async (dispatch) => {
    dispatch(setForm(action))
  }
}

const kidsRequest = async () => {
  const body = { device: 'chrome' }
  const { token } = getUserData()

  const res = await fetch(endpoints.kidsList, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // 'user-Agent': 'pdtest-android/100.0.0',
      'x-access-token': token
    },
    data: body
  })

  const kids = await res.json()
  if (kids.error) {
    return 'duplicate'
  }

  const kidOptions = []
  kids.children.map((kid) => {
    const newItem = {
      label: kid.name,
      value: kid._id
    }
    kidOptions.push(newItem)
  })

  return {
    list: kids.children,
    options: kidOptions
  }
}

export const loadKids = () => {
  return async (dispatch) => {
    const res = await kidsRequest()

    console.log(res)
    if (res === 'duplicate') {
      return dispatch(setAlertModal(true))
    }

    dispatch(setKidsList(res))
  }
}

export const addKid = (body) => {
  return async (dispatch) => {
    const { token, _id } = getUserData()

    const requestBody = {
      user_id: _id,
      children: body
    }

    const res = await fetch(endpoints.addKid, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      },
      body: JSON.stringify(body)
    })

    const kids = await kidsRequest()
    dispatch(setKidsList(kids))
    dispatch(setInfoModal(true))
  }
}

export const updateKid = (body) => {
  return async (dispatch) => {
    const { token, _id } = getUserData()

    const res = await fetch(endpoints.updateKid, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      },
      body: JSON.stringify(body)
    })

    const kids = await kidsRequest()
    dispatch(setKidsList(kids))
  }
}

export const deleteKid = () => {
  return async (dispatch, getState) => {
    const { token } = getUserData()
    const body = getState().kidsList.selectedKid

    const res = await fetch(endpoints.deleteKid, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      },
      body: JSON.stringify(body)
    })

    const kids = await kidsRequest()
    dispatch(setKidsList(kids))
  }
}

export const updateKidStatus = () => {
  return async (dispatch, getState) => {
    const { token } = getUserData()
    const body = getState().kidsList.selectedKid

    const res = await fetch(endpoints.updateKidStatus, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      },
      body: JSON.stringify(body)
    })

    const kids = await kidsRequest()
    dispatch(setKidsList(kids))
  }
}

export const handleModal = (action) => {
  return async (dispatch) => {
    dispatch(setAlertModal(action))
  }
}
export const handleInfoModal = (action) => {
  return async (dispatch) => {
    dispatch(setInfoModal(action))
  }
}
export const handleStatusModal = (action) => {
  return async (dispatch) => {
    dispatch(setStatusModal(action))
  }
}
export const handleUpdateModal = (action) => {
  return async (dispatch) => {
    dispatch(setUpdateModal(action))
  }
}

export const handleSetAction = (action) => {
  return async (dispatch) => {
    dispatch(setAction(action))
  }
}
export const handleSelectedKid = (body) => {
  return async (dispatch) => {
    dispatch(setSelectedKid(body))
  }
}

export const getRecord = (body) => {
  return async (dispatch) => {
    const { token } = getUserData()

    const res = await fetch(endpoints.getRecord, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      },
      body: JSON.stringify(body)
    })

    const response = await res.json()
    if (response.error) {
      return dispatch(setAlertModal(true))
    }

    dispatch(setRecordData(response.transactions))
  }
}

export const getFormChildrenInfo = () => {
  return async (dispatch) => {
    const { _id, token } = getUserData()
    const body = { user_id: _id }

    const res = await fetch(endpoints.getFormInfo, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      },
      body: JSON.stringify(body)
    })

    const response = await res.json()

    const commers = []
    response.commerces.map((commerce) => {
      const newItem = {
        label: commerce.school_name,
        value: commerce._id
      }
      commers.push(newItem)
    })

    const design = []
    response.design.map((commerce) => {
      const newItem = {
        label: commerce.name,
        value: commerce.value
      }
      design.push(newItem)
    })

    dispatch(
      setFormInfo({
        school: commers,
        carnet: design
      })
    )
  }
}

export const getRechargeMethods = () => {
  return async (dispatch) => {
    const { _id, token } = getUserData()

    const res = await fetch(endpoints.getRechargeMethods, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      }
    })
    const response = await res.json()

    const options = []
    response.recharge_methods.map((item) => {
      const newOption = {
        label: item.title,
        value: item.type,
        instructions: item.instructions
      }
      options.push(newOption)
    })

    dispatch(setRechargeMethods(options))
  }
}

export const getConstans = () => {
  return async (dispatch) => {
    const { _id, token } = getUserData()

    const res = await fetch(endpoints.getConstans, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      }
    })
    const response = await res.json()

    const mobile_payment = response.BANK_ACCOUNTS.mobile_payment
    const wiretransfer = response.BANK_ACCOUNTS.wiretransfer
    const bankList = response.BANK_LIST

    const bankOptions = []

    bankList.map((bank) => {
      const newOptions = {
        label: `${bank.prefix}-${bank.name}`,
        value: bank.prefix,
        name: bank.name,
        shortName: bank.short_name
      }
      if (bank.active) {
        bankOptions.push(newOptions)
      }
    })

    dispatch(setBankOptions(bankOptions))
    dispatch(setMobilePayment(mobile_payment))
    dispatch(setWiretransfer(wiretransfer))
  }
}

export const selectedMethod = (option) => {
  return async (dispatch) => {
    dispatch(setSelectedMethod(option))
  }
}

export const handleRechargeMethodModal = (action) => {
  return async (dispatch) => {
    dispatch(setRechargeMethodsModal(action))
  }
}

export const rechargeBankTransfer = (body) => {
  return async (dispatch) => {
    const { _id, token } = getUserData()
    try {
      const res = await fetch(endpoints.bankTransferRecharge, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        body: JSON.stringify(body)
      })
      const response = await res.json()
      dispatch(setRechargeMethodsModal(false))
      if (res.ok) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={response.message}
            type={'success'}
          />
        ))
        return
      }
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'No fue posible realizar su solicitud'}
          type={'danger'}
        />
      ))
    } catch (error) {
      console.log(error)
    }
  }
}

const getUserFoundRequest = async () => {
  try {
    const { _id, token } = getUserData()
    const res = await fetch(endpoints.getFunds, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // 'user-Agent': 'pdtest-android/100.0.0',
        'x-access-token': token
      }
    })
    const response = await res.json()
    return response
  } catch (error) {
    console.log(error)
  }
}

export const bancamigaRecharge = (otp, body) => {
  return async (dispatch) => {
    const { _id, token } = getUserData()
    try {
      const resOtp = await fetch(endpoints.sendOtp, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'user-Agent': 'pdtest-android/100.0.0',
          'x-access-token': token
        },
        body: JSON.stringify(otp)
      })
      const response = await resOtp.json()

      if (!resOtp.ok) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={
              response.description || 'No fue posible realizar su recarga'
            }
            type={'danger'}
          />
        ))
        return 'error'
      }

      const tranferInfo = {
        ...body,
        bank_details: response.bank_details
      }

      dispatch(setTransferInfo(tranferInfo))
      dispatch(setTypeOtp(false))

      if (response.otp_needed) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={'Se envió una clave dinámica a su dispositivo '}
            type={'success'}
          />
        ))
        return 'otpTrue'
      }

      const res2 = await fetch(endpoints.creditRecharge, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'user-Agent': 'pdtest-android/100.0.0',
          'x-access-token': token
        },
        body: JSON.stringify(tranferInfo)
      })
      const response2 = await res2.json()

      if (!res2.ok) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={
              response2.error.description || 'No fue posible realizar su recarga'
            }
            type={'danger'}
          />
        ))
        return 'error'
      }

      const funds = await getUserFoundRequest()
      dispatch(setFunds(funds?.user_funds))

      toast((t) => (
        <BasicToastContent
          t={t}
          message={'Su recarga fue realizada de forma exitosa'}
          type={'success'}
        />
      ))
      return 'otpFalse'
    } catch (error) {
      console.log(error)
    }
  }
}

export const setFundsRequest = (otp) => {
  return async (dispatch, getState) => {
    const response = await getUserFoundRequest()
    dispatch(setFunds(response?.user_funds))
  }
}

export const confirmOtp = (otp) => {
  return async (dispatch, getState) => {
    try {
      const { _id, token } = getUserData()
      const transferInfo = getState().kidsList.transferInfo
      const body = {
        ...transferInfo,
        otp
      }

      const res = await fetch(endpoints.creditRecharge, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'user-Agent': 'pdtest-android/100.0.0',
          'x-access-token': token
        },
        body: JSON.stringify(body)
      })
      const response = await res.json()

      if (!res.ok) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={
              response.description || 'No fue posible realizar su recarga'
            }
            type={'danger'}
          />
        ))
        return 'error'
      }

      const funds = await getUserFoundRequest()
      dispatch(setFunds(funds?.user_funds))
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'Su recarga fue realizada de forma exitosa'}
          type={'success'}
        />
      ))
    } catch (error) {
      console.log(error)
    }
  }
}

export const bdvRecharge = (body) => {
  return async (dispatch) => {
    const { _id, token, email } = getUserData()
    try {
      const sendBody = {
        ...body,
        email
      }
      
      const res = await fetch(endpoints.bdvRecharge, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'user-Agent': 'pdtest-android/100.0.0',
          'x-access-token': token
        },
        body: JSON.stringify(sendBody)
      })
      const response = await res.json()

      if (!res.ok) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={
              response.error.description || 'No fue posible realizar su recarga'
            }
            type={'danger'}
          />
        ))
        return 'error'
      }

      dispatch(setTransferInfo({ transaction_id: response.data.transactionId }))
      dispatch(setTypeOtp(true))

      toast((t) => (
        <BasicToastContent
          t={t}
          message={'Se envió una clave dinámica a su dispositivo '}
          type={'success'}
        />
      ))
      return 'otpTrue'
    } catch (error) {
      console.log(error)
    }
  }
}

export const bdvRechargeConfirm = (body) => {
  return async (dispatch, getState) => {
    try {
      const { _id, token, email } = getUserData()
      const transferInfo = getState().kidsList.transferInfo.transaction_id

      const sendBody = {
        token: body,
        transaction_id: transferInfo
      }

      const res = await fetch(endpoints.bdvRechargeConfirm, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 'user-Agent': 'pdtest-android/100.0.0',
          'x-access-token': token
        },
        body: JSON.stringify(sendBody)
      })
      const response = await res.json()

      if (!res.ok) {
        toast((t) => (
          <BasicToastContent
            t={t}
            message={
              response.description || 'No fue posible realizar su recarga'
            }
            type={'danger'}
          />
        ))
        return 'error'
      }
      
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'Su recarga fue realizada de forma exitosa'}
          type={'success'}
        />
      ))
    } catch (error) {
      console.log(error)
    }
  }
}
